// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, no-negated-condition */
import { createSelector, OutputSelector } from "reselect"
import Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import { INSURANCE_NAMES } from "@kiwicom/frontend-common/consts/insurance"
import { INIT } from "@kiwicom/frontend-common/consts/phase"
import Price from "@kiwicom/frontend-common/records/Price"
import {
  UsInsuranceAncillariesPassenger,
  bookingDataSelector,
} from "@kiwicom/frontend-common/services/booking/booking"
import type { PhaseType } from "@kiwicom/frontend-common/consts/phase"
import { Record, Map } from "immutable"

import {
  ancillaryAxaInsuranceOffersSelector,
  axaAncillarySelector,
} from "../../../../BookingAncillary/services/BookingAncillaryDuck"
import type {
  AxaInsuranceAncillaries,
  AncillariesPassengerOffers,
  AXASelectedOptionsRequest,
  AxaInsuranceLevel,
} from "../../../../BookingAncillary/consts/types"
import Booking from "../../../../../../../../../records/Booking"
import type { TabType } from "../types"

type PassengersSelectionPerType = Map<number, AxaInsuranceLevel>

// @ts-expect-error: Flow to TS migration.
export type BookingInsurance = Record<{
  passengers: Map<"tabType", Map<TabType, PassengersSelectionPerType>>
  activeTabType: TabType
  phase: PhaseType
  error: string
  usLoading: boolean
}>

// Global state that we are accessing in this selectors
export type State = {
  data: Booking
  // Selected option, but not initial option since initial
  // option is available in orders
  bookingInsurance: BookingInsurance
  ancillaries: {
    // AXA orders
    ancillaries: {
      axa: AxaInsuranceAncillaries
    }
    // AXA offers
    offers: AncillariesPassengerOffers
  }
}

// Redux state selectors
export const bookingInsuranceSelector = (state: State): BookingInsurance => state.bookingInsurance

// @ts-expect-error: Flow to TS migration.
export const activeTabTypeSelector: OutputSelector<
  State,
  undefined,
  TabType
> = createSelector(bookingInsuranceSelector, (insurance) => insurance.get("activeTabType"))

// @ts-expect-error: Flow to TS migration.
export const passengerInsuranceSelectionPerTabTypeSelector: OutputSelector<
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  undefined,
  PassengersSelectionPerType
> = createSelector([bookingInsuranceSelector, activeTabTypeSelector], (insurance, activeTabType) =>
  insurance.getIn(["passengers", "tabType", activeTabType]),
)

/**
 * checks if any passenger has selected an insurance level in the tab type passed to the selector
 */
// @ts-expect-error: Flow to TS migration.
export const isAnyLevelSelectedInTabTypeSelector: OutputSelector<
  State,
  {
    tabType: TabType
  },
  boolean
> = createSelector(
  [
    (state: State) => bookingInsuranceSelector(state),
    (
      _: State,
      props: {
        tabType: TabType
      },
    ) => props.tabType,
  ],
  (insurance, tabType) => insurance.getIn(["passengers", "tabType", tabType]).size > 0,
)

/**
 * calculates final price based on user selection, data is taken based on {@link activeTabType}
 */
// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const priceSelector: OutputSelector<State, any, number> = createSelector(
  [
    bookingDataSelector,
    bookingInsuranceSelector,
    passengerInsuranceSelectionPerTabTypeSelector,
    ancillaryAxaInsuranceOffersSelector,
    axaAncillarySelector,
  ],
  (
    booking,
    bookingInsurance,
    passengerInsuranceSelectionPerTabType,
    passengerOffers,
    passengerOrders,
  ) => {
    const zeroPrice = new Price({ amount: 0 })

    return (
      // @ts-expect-error: Flow to TS migration.
      booking.passengers
        // @ts-expect-error: Flow to TS migration.
        .filter((pap) => passengerInsuranceSelectionPerTabType.has(pap.id))
        // @ts-expect-error: Flow to TS migration.
        .reduce((total, pap) => {
          // @ts-expect-error: Flow to TS migration.
          const selected = passengerInsuranceSelectionPerTabType.get(Number(pap.id))
          // @ts-expect-error: Flow to TS migration.
          const paxOffer = passengerOffers.find((offer) => offer.passengerId === Number(pap.id))
          const selectedPrice = paxOffer ? paxOffer.options[selected] : zeroPrice

          // @ts-expect-error: Flow to TS migration.
          const existingOrder = passengerOrders.reduce(
            // @ts-expect-error: Flow to TS migration.
            (acc, curr) => {
              // @ts-expect-error: Flow to TS migration.
              const order = curr.items.find((item) => {
                return item.isActive && item.id === Number(pap.id)
              })

              return order || acc
            },
            { price: zeroPrice },
          )

          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
          const price = total + selectedPrice.amount - existingOrder.price.amount

          // Round to 2 decimal places
          return Math.round(price * 100) / 100
        }, 0)
    )
  },
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showSelector: OutputSelector<State, any, boolean> = createSelector(
  bookingInsuranceSelector,
  passengerInsuranceSelectionPerTabTypeSelector,
  // there's a change and phase's init
  (insurance, passengerInsuranceSelectionPerTab) =>
    // @ts-expect-error: Flow to TS migration.
    !(passengerInsuranceSelectionPerTab.size === 0 && insurance.phase === INIT),
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const translationSelector: any = createSelector([priceSelector], (price) => {
  if (price > 0) {
    // @ts-expect-error: Flow to TS migration.
    return __("mmb.additional_services.payment_cta.checkout")
  }

  if (price < 0) {
    // @ts-expect-error: Flow to TS migration.
    return __("account.insurance.refund")
  }

  return "submit"
})

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dataSelector: OutputSelector<State, any, AXASelectedOptionsRequest[]> = createSelector(
  [passengerInsuranceSelectionPerTabTypeSelector],
  (passengerInsuranceSelectionPerTab) => {
    // Fix this the next time the file is edited. (Flow to TS)
    // @ts-expect-error: Flow to TS migration.
    // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
    return passengerInsuranceSelectionPerTab.keySeq().reduce<Array<any>>(
      // @ts-expect-error: Flow to TS migration.
      (output, pid) => [
        ...output,
        {
          insurance_type:
            // @ts-expect-error: Flow to TS migration.
            passengerInsuranceSelectionPerTab.get(pid) === INSURANCE_NAMES.NONE
              ? null
              : // @ts-expect-error: Flow to TS migration.
                passengerInsuranceSelectionPerTab.get(pid),
          passenger_id: pid,
        },
      ],
      [],
    )
  },
)

// TODO https://jira.kiwi.com/browse/MMB-2147 possibly update after we have answer from @marta.juric
// alternatively create passenger by countries and pass a list of countires to the selector via props
// usage excludedPassengersByCountry(state, { countries: blacklisted_list})
// @ts-expect-error: Flow to TS migration.
export const nonUSPassengersSelector: OutputSelector<
  {
    data: Booking
  },
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Passenger[]
> = createSelector(bookingDataSelector, ({ passengers }) =>
  // @ts-expect-error: Flow to TS migration.
  passengers.filter(({ nationality }) => nationality !== "us"),
)

// TODO https://jira.kiwi.com/browse/MMB-2147 possibly update after we have answer from @marta.juric
// usage pickPassengersByCountry/Nationality(state, { countries: ["cz", "si"]})
// @ts-expect-error: Flow to TS migration.
export const usPassengerSelector: OutputSelector<
  {
    data: Booking
  },
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Passenger[]
> = createSelector(bookingDataSelector, ({ passengers }) =>
  // @ts-expect-error: Flow to TS migration.
  passengers.filter(({ nationality }) => nationality === "us"),
)

export const reducePrice = (
  total: Price | null | undefined,
  item: UsInsuranceAncillariesPassenger,
): Price =>
  !total
    ? item.price
    : new Price({
        currency: item.price.currency,
        amount: item.price.amount + total.amount,
        base: item.price.base + total.base,
        merchant: item.price.merchant + total.merchant,
        service: item.price.service + total.service,
        // @ts-expect-error: Flow to TS migration.
        service_flat: item.price.serviceFlat + total.serviceFlat,
      })

export const passengerIdFromPropsSelector = (
  state: {
    data: Booking
  },
  props?: {
    passenger: Passenger
  } | null,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
) => props?.passenger?.id

export const getTabType = (nonUSPassengers: Passenger[]): TabType => {
  const paxInsurances = nonUSPassengers.map((pap: Passenger) => pap.insurance)

  if (paxInsurances.every((insurance) => insurance === INSURANCE_NAMES.NONE)) {
    return "upgrade"
  }
  if (paxInsurances.every((insurance) => insurance === INSURANCE_NAMES.PLUS)) {
    return "downgrade"
  }
  return "combo"
}

/**
 * Display tabs when passengers have different levels of insurance.
 * Tabs are hidden when all passengers have 'none' (it is the lowest level, so downgrade not possible)
 * or 'plus' (it is the highest level, so upgrade not possible).
 */
// @ts-expect-error: Flow to TS migration.
export const shouldShowUpgradeDowngradeTabsSelector: OutputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  boolean
> = createSelector(
  [nonUSPassengersSelector],
  (nonUSPassengers) => getTabType(nonUSPassengers) === "combo",
)
